// src/metadata.js
export const metadata = {
    title: "Home - Bonne Santé Health Service Limited",

  };
  